type CardRecord = Record<string, unknown>;

const attributesOf = (item: CardRecord | undefined): CardRecord =>
  (item?.attributes as CardRecord | undefined) ?? item ?? {};

const mediaUrl = (media: unknown): string | undefined => {
  const node = media as CardRecord | undefined;
  const data = node?.data as CardRecord | undefined;
  const attributes = data?.attributes as CardRecord | undefined;
  return (attributes?.url ?? data?.url ?? node?.url) as string | undefined;
};

const documentIdOf = (item: CardRecord): string | undefined => {
  const attributes = attributesOf(item);
  return (attributes.documentId ?? item.documentId) as string | undefined;
};

export const resolveCardImage = (item: CardRecord | undefined): string | undefined => {
  const attributes = attributesOf(item);
  return (
    (attributes.poster_url as string | undefined) ||
    (item?.poster_url as string | undefined) ||
    (attributes.bunny_image as string | undefined) ||
    (item?.bunny_image as string | undefined) ||
    mediaUrl(attributes.thumbnail ?? item?.thumbnail)
  );
};

export const dedupeByDocumentId = <T extends CardRecord>(items: readonly T[] = []): T[] => {
  const seen = new Set<string>();
  return items.filter((item) => {
    const documentId = documentIdOf(item);
    if (!documentId) return true;
    if (seen.has(documentId)) return false;
    seen.add(documentId);
    return true;
  });
};

export const resolveContentType = (item: CardRecord | undefined): 'Filme' | 'Série' | undefined => {
  const attributes = attributesOf(item);
  const rawType = (attributes.media_type ??
    attributes.content_type ??
    item?.media_type ??
    item?.content_type) as string | undefined;
  const categoriesNode = attributes.categories as CardRecord | CardRecord[] | undefined;
  const categories = Array.isArray(categoriesNode)
    ? categoriesNode
    : ((categoriesNode?.data as CardRecord[] | undefined) ?? []);
  const normalized = [
    rawType,
    ...categories.map((category) => attributesOf(category).name as string | undefined),
  ]
    .filter((value): value is string => typeof value === 'string')
    .map((value) => value.toLocaleLowerCase('pt-BR'))
    .find((value) =>
      ['tv', 'series', 'serie', 'série', 'séries', 'movie', 'film', 'filme', 'filmes'].includes(
        value,
      ),
    );

  if (normalized && ['tv', 'series', 'serie', 'série', 'séries'].includes(normalized))
    return 'Série';
  if (normalized && ['movie', 'film', 'filme', 'filmes'].includes(normalized)) return 'Filme';
  return undefined;
};
